module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#edit",
      toString: function () {
        return this.url;
      }
    }